export default {
	footer: {
		ageRestriction: "Platform kami hanya untuk pengguna berusia 18 tahun ke atas. Perjudian dapat menyebabkan kecanduan. Harap bermain secara bertanggung jawab dan hanya untuk hiburan. Untuk informasi lebih lanjut, kunjungi halaman Perjudian yang Bertanggung Jawab kami.",
		followUs: "IKUTI KAMI",
		company: "PERUSAHAAN",
		legal: "HUKUM",
		support: "DUKUNGAN",
		gameProviders: "PENYEDIA GAME",
		copyright: "Copyright © 2019-2026 LOGO. Semua Hak Dilindungi Undang-Undang.",
		documents: "Dokumen",
	}
}